<template>
<div>
  <div class="modal" id="livestream_scanner"  data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
            
              <h4 class="modal-title">
                  <span class="fas fa-camera mr-2" aria-hidden="true"></span> 
                  BARCODE SCANNER</h4>
               <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>        
                
            </div>
            <div class="modal-body" style="position: static">
                <div id="interactive" class="viewport"></div>
                <div class="error"></div>
            </div>
            <div class="modal-footer">
        
                <button type="button" class="btn btn-primary" data-dismiss="modal">Chiudi</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>         
        

</div>
</template>
<script>
import Quagga from 'quagga'


export default {
 
  props: [''],
  components : {},
  data () {
    return {
       
    }
  },
  computed: 
  {
    
  },
  mounted()
    {
     var _this = this
      $('#livestream_scanner').on('shown.bs.modal', function (e) {

         Quagga.init({

            inputStream : {
            name : "Live",
            type : "LiveStream",
            //target: document.querySelector('#stream'),    // Or '#yourElement' (optional)
            constraints: {
                width: 640,
                height: 480,
                aspectRatio: {min: 1, max: 100},
                facingMode: "environment"},
            },
            decoder : {
                readers : ["ean_reader"]
                },
            locate: true
  }, function(err) {
      if (err) {
        $('#livestream_scanner .modal-body .error').html('<div class="alert alert-danger"><strong><i class="fa fa-exclamation-triangle"></i> '+ err.name + '</strong>: ' + err.message + '</div>');
          Quagga.stop()
          console.log(err);
          return
      }
      console.log("Initialization finished. Ready to start");
      Quagga.start();
  });

})
    
    $('#livestream_scanner').on('hide.bs.modal', function(){
        if (Quagga)
        {
            Quagga.stop();  
        }
    });
      // Make sure, QuaggaJS draws frames an lines around possible 
    // barcodes on the live stream
    Quagga.onProcessed(function(result) 
    {
        var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;
 
        if (result) 
        {
            if (result.boxes) 
            {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }
 
            if (result.box) 
            {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }
 
            if (result.codeResult && result.codeResult.code) 
            {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    });
    
    // Once a barcode had been read successfully, stop quagga and 
    // close the modal after a second to let the user notice where 
    // the barcode had actually been found.
    Quagga.onDetected(function(result) 
    {   
             
        if (result.codeResult.code)
        {
     
            Quagga.stop();  
            _this.$emit('update',result.codeResult.code)
            $('#livestream_scanner').modal('hide')

            //setTimeout(function(){ $('#livestream_scanner').modal('hide'); }, 1000);            
        }
    });
  

    },
  methods: 
    {

    }

    
    
  
}
</script>
<style scoped>
h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
#interactive.viewport {position: relative; width: 100%; height: auto; overflow: hidden; text-align: center;}
	#interactive.viewport > canvas, #interactive.viewport > video {max-width: 100%;width: 100%;}
	canvas.drawing, canvas.drawingBuffer {position: absolute; left: 0; top: 0;}

 .modal .modal-body { /* Vertical scrollbar if necessary */
    max-height: 480px;
    overflow-y: auto;
}    
</style>

